import React from "react";
import Routers from "./Routers";
import CallBar from "./Components/CallBar";
import ChatBot from "./Components/ChatBot";
import usePageTracking from "./hooks/usePageTracking";

function App() {
  usePageTracking();

  return (
    <div>
      <Routers />
      <CallBar />
      <ChatBot />
    </div>
  );
}

export default App;
